module.exports = __webpack_public_path__ + "static/img/sdl_logo_big@3x.9e52c4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/logos/3x/sdl_logo_big@3x.png
// module id = +l0R
// module chunks = 1